// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"9392b8f2","703":"e176f19b","787":"7f04b3cf"}[chunkId] + ".chunk.js";
};